import React from 'react';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import uploadPNWContest from './uploadPNW';

const PredictAndWinDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.predictAndWinV2}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.predictAndWinV2].uploadContest]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/uploadContest`}
				component={uploadPNWContest}
				exact
			/>
			<Redirect to={`${path}/uploadContest`} />
		</Switch>
	);
};

export default PredictAndWinDashboard;
